import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { setIsCompleteAuctionModalOpen, completeAuction } from 'store/actions';
import { selectedAuctionTxnOppsSelector } from 'store/selectors';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    IconButton
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

const styles = theme => ({
    caption: {
        marginTop: 8
    },
    content: {
        fontSize: '16px'
    },
    closeButton: {
        position: 'absolute',
        right: 0,
        top: 0,
        backgroundColor: '#ffffff'
    },
});

const CompleteAuctionModal = ({ classes, selectedTask, selectedAuctionTxnOpps, isCompleteAuctionModalOpen, setIsCompleteAuctionModalOpen, completeAuction }) => {

    const handleCancel = (e, reason) => {
        if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
        setIsCompleteAuctionModalOpen(false);
    }

    const handleComplete = () => {
        // Send complete action
        completeAuction(selectedTask.id);
        setIsCompleteAuctionModalOpen(false);
    }

    let titleText = '';
    let contentText = '';
    let auctionTxnOppsCount = 0;

    if (selectedAuctionTxnOpps) {
        auctionTxnOppsCount = selectedAuctionTxnOpps.length;
    }

    if (isCompleteAuctionModalOpen && selectedTask) {
        titleText = `Complete auction ${selectedTask.portfolioName}?`;
        // contentText = `${auctionTxnOppsCount} transaction ${auctionTxnOppsCount > 1 ? 'opportunities' : 'opportunity'} will be closed.`;
        contentText = ``;
    }

    return (
        <Dialog open={isCompleteAuctionModalOpen} onClose={handleCancel}>
            <DialogTitle className={classes.caption}>
                {titleText}
            </DialogTitle>
            <IconButton className={classes.closeButton} onClick={handleCancel}>
                <ClearIcon fontSize="inherit" />
            </IconButton>
            <DialogContent className={classes.content}>
                <DialogContentText id="alert-dialog-description">
                    {contentText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button onClick={handleComplete} variant="contained" color="primary">Complete</Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => ({
    isCompleteAuctionModalOpen: state.auctionUWState.isCompleteAuctionModalOpen,
    selectedAuctionTxnOpps: selectedAuctionTxnOppsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    setIsCompleteAuctionModalOpen: (isOpen) => dispatch(setIsCompleteAuctionModalOpen(isOpen)),
    completeAuction: (auctionId) => dispatch(completeAuction(auctionId)),
});

export default compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(CompleteAuctionModal);